import { CEFR_LEVELS } from '@repo/config';
import { z } from 'zod';

const listSysGrammarPointsV1RequestSchemaDefinition = z.object({
  level: z.enum(CEFR_LEVELS).optional(),
  family: z.string().min(1).optional(),
  approved: z
    .enum(['true', 'false'])
    .transform((value) => value === 'true')
    .optional(),
  cursor: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export const listSysGrammarPointsV1RequestSchema: typeof listSysGrammarPointsV1RequestSchemaDefinition =
  listSysGrammarPointsV1RequestSchemaDefinition;

export type IListSysGrammarPointsV1Request = z.infer<
  typeof listSysGrammarPointsV1RequestSchemaDefinition
>;
